import {post} from '@/utils/request';
import {erpserver,erpplatserver,oaserver,sse_url} from '@/utils/baseUrl';
const api={
    payment:oaserver+'/payment',
    oacurrency:oaserver+'/oacurrency'
}

//汇票导入
export async function importFile(params) {
    return post(api.payment+'/excel/import', params, false);
}
//文件名称验证
export async function validName(params) {
    return post(api.payment+'/excel/validName', params, true);
}
export async function closeSSE(params) {

    return post(sse_url+'/close/'+params.userId, params, true)
}
//汇票处理账款
export async function processData(params) {
    return post(api.payment+'/excel/processData', params, true);
}
//列表
export async function getImportResults(params) {
    return post(api.payment+'/excel/getImportResults', params, true);
}



//------------------------------------------------------

//汇票列表
export async function getBillList(params) {
    return post(api.payment+'/getBillList', params, true);
}
//汇票详情
export async function getBillDetail(params) {
    return post(api.payment+'/getBillDetail', params, true);
}


//获取币种
export async function getDictList(params) {
    return post(api.oacurrency+'/getDictList', params, true);
}
//公司
export async function getCompanyList(params) {
    return post(api.oacurrency+'/getCompanyList', params, true);
}

//客户
export async function getCustomers(params) {
    return post(api.payment+'/getCustomers', params, true);
}